import React from 'react';
import { Section } from './ui/Section';
import { X, Check } from 'lucide-react';
export function UniqueMechanism() {
  return <Section className="bg-amber-50" data-id="element-151">
      <div className="max-w-3xl mx-auto" data-id="element-152">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-153">
          Por qué esto es diferente
        </h2>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-154">
          <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-gray-100" data-id="element-155">
            <div className="p-8 bg-gray-50" data-id="element-156">
              <h3 className="text-lg font-bold text-gray-500 mb-6 uppercase tracking-wide text-center" data-id="element-157">
                Otros Cursos
              </h3>
              <ul className="space-y-4" data-id="element-158">
                <li className="flex items-start text-gray-600" data-id="element-159">
                  <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-160" />
                  <span data-id="element-161">Te piden ser influencer y bailar en TikTok</span>
                </li>
                <li className="flex items-start text-gray-600" data-id="element-162">
                  <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-163" />
                  <span data-id="element-164">Necesitas computadora y software caro</span>
                </li>
                <li className="flex items-start text-gray-600" data-id="element-165">
                  <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-166" />
                  <span data-id="element-167">Te hablan con términos técnicos complicados</span>
                </li>
                <li className="flex items-start text-gray-600" data-id="element-168">
                  <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-169" />
                  <span data-id="element-170">Asumen que tienes 8 horas libres al día</span>
                </li>
              </ul>
            </div>

            <div className="p-8 bg-white" data-id="element-171">
              <h3 className="text-lg font-bold text-emerald-600 mb-6 uppercase tracking-wide text-center" data-id="element-172">
                Mamá Digital
              </h3>
              <ul className="space-y-4" data-id="element-173">
                <li className="flex items-start text-gray-800 font-medium" data-id="element-174">
                  <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-175" />
                  <span data-id="element-176">Ventas privadas por WhatsApp (sin bailes)</span>
                </li>
                <li className="flex items-start text-gray-800 font-medium" data-id="element-177">
                  <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-178" />
                  <span data-id="element-179">100% desde tu celular actual</span>
                </li>
                <li className="flex items-start text-gray-800 font-medium" data-id="element-180">
                  <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-181" />
                  <span data-id="element-182">Lenguaje sencillo, de mamá a mamá</span>
                </li>
                <li className="flex items-start text-gray-800 font-medium" data-id="element-183">
                  <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-184" />
                  <span data-id="element-185">Bloques pequeños de tiempo (siestas/noches)</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}